/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit NoOption/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import Radial from 'DesignSystem/Radial/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function NoOption({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/TreatmentPlans/Content/AcceptTreatmentAction/Content/FinancialsManagedExternally/Flow/NoOption"
  
}) {
let financialFlowSelectedValueData = fromData.useDataFormat({ viewPath,
context: 'financial_flow',
path: 'selected',
format: fromFormat.not,
})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<Radial
  viewPath={`${viewPath}/Radial`}
 data="financial_flow.selected"
 format="/Data/format.js not"
 isSelected={financialFlowSelectedValueData}
 onClick={onClick}
 text="No"
/>
{children}
</React.Fragment>)
}